import React from 'react';
import { styles } from './TextBlock.css';
import { LoadingSkeletonProps } from '../../Base/Base';
import { PossiblyResponsiveValue, useResponsiveValue } from '../../../hooks/useResponsiveValue';
import { TextLine } from '../TextLine/TextLine';

type TextBlockSkeletonProps = {
  lines?: PossiblyResponsiveValue<number | Array<LoadingSkeletonProps>>;
};

export const TextBlock = ({
  lines: linesProp = [{ width: '250px' }, { width: '175px' }, { width: '225px' }],
}: TextBlockSkeletonProps) => {
  const lines = useResponsiveValue(linesProp);
  return (
    <div className={styles.container}>
      {(Array.isArray(lines) ? lines : [...Array(lines).keys()]).map((line, i) => {
        return <TextLine key={i} {...(typeof line === 'number' ? {} : line)} />;
      })}
    </div>
  );
};
